module.exports = __webpack_public_path__ + "img/canbadge_round_25mm_trimmark.76e185dc.png";